module.exports = __webpack_public_path__ + "static/media/silver.abe61a94.png";